import {
    useMemo,
} from 'react'
import {
    useSkyNetNavigate,
} from 'app/SkyNetRoutes/index'
import {
    createRoutesConfig,
} from 'app/SkyNetRoutes/skyNetRoutes.utils'
import {
    SkyNetRoutesConfig,
} from 'app/SkyNetRoutes/SkyNetRoutes.types'
import {
    App,
    RatesDomains,
    RateCardsTabs,
} from 'app/enums/domain.enums'

export default function useRatesRoutes() {
    const skyNetNavigate = useSkyNetNavigate()

    return useMemo(() => {
        const config: SkyNetRoutesConfig = {
            path: [App.Rates],
            RateCards: {
                route: RatesDomains.RateCards,
                ...(Object.entries(RateCardsTabs).reduce((acc, [
                    key,
                    value,
                ]) => {
                    return {
                        ...acc,
                        [key]: {
                            route: value,
                        },
                    }
                }, {})),
            },
        }

        return createRoutesConfig(skyNetNavigate)(config)
    }, [skyNetNavigate])
}
